import app from '../app.first';

app.LegaciesSlider = class extends app.Component {
  onReady() {
    $(".slider-window").slick({
      infinite: true,
      speed: 500,
      autoplay: true,
      arrows: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: true,
      responsive: [
        {
          breakpoint: 1224,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false
          }
        }
      ]
    })
    
    $(".slick-arrow").each(function (index) {
      if (index === 1) {
        $(this).html("<img src='/img/icons/next_arrow.png'>")
      } else {
        $(this).html("<img src='/img/icons/previous_arrow.png'>")
      }
    })
  }
}